export interface FilterOption {
  label: string;
  value: string;
}
export enum FilterType {
  CHECKLIST = 'checklist',
  AUTOCOMPLETE_CHECKLIST = 'autocomplete_checklist',
  FREE_SEARCH = 'free_search',
  DATE_PICKER = 'date_picker',
  SELECT = 'select'
}

export interface FilterPopoverProps {
  label: string;
  labelParts?: string[];
  options?: FilterOption[];
  selectedItems?: string[];
  selectionCount?: number;
  onChange?: (value: string) => void;
  onSelectionChange?: (items: string[]) => void;
  filterType: FilterType;
  placeholder?: string;
  hideIndicator?: boolean;
  dataTestId?: string;
  isLocalTime?: boolean;
  popoverHeight?: string;
  singleSelect?: boolean;
  minLength?: number;
  maxLength?: number;
}
